import classNames from 'classnames';
import './MailPreview.scss';
import { XIcon } from 'fasoo-ui-component-next';
import encMailApprovalApi, { EncMailApprovalDetailEntity } from 'src/api/user/encMailApprovalApi';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import exchangeFullApprovalApi, {
  ExchangeFullApprovalDetailEntity,
} from 'src/api/user/exchangeFullApprovalApi';

interface MailPreviewProps {
  encMailApproval: EncMailApprovalDetailEntity | null;
  exchangeFullApproval: ExchangeFullApprovalDetailEntity | null;
  onClose: () => void;
}

export const MailPreview: React.FC<MailPreviewProps> = ({
  encMailApproval,
  exchangeFullApproval,
  onClose,
}) => {
  const { t } = useTranslation(['encMail']);
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    if (encMailApproval) {
      encMailApprovalApi
        .preview({
          userName: encMailApproval.userName,
          userId: encMailApproval.userId,
          subject: encMailApproval.subject,
          content: encMailApproval.content,
          detailEntity: encMailApproval,
          contentType: encMailApproval.contentType,
        })
        .then((value) => setContent(value));
    } else if (exchangeFullApproval) {
      exchangeFullApprovalApi
        .preview({
          userName: exchangeFullApproval.userName,
          userId: exchangeFullApproval.userId,
          subject: exchangeFullApproval.subject,
          content: exchangeFullApproval.content,
          detailEntity: exchangeFullApproval,
          contentType: exchangeFullApproval.contentType,
        })
        .then((value) => setContent(value));
    }
  }, [encMailApproval, exchangeFullApproval]);

  if ((encMailApproval === null && exchangeFullApproval === null) || content === '') {
    return null;
  }
  const htmlContent = encMailApproval?.content || exchangeFullApproval?.content || '';

  return (
    <div className={classNames('mail-preview-maincontainer')}>
      <div className="header-area">
        <div className="header-side-area-left">dummy </div>
        <div className="header-title-area">{t('encMail:detailPopup.title')}</div>
        <div onClick={onClose} className="header-side-area">
          <XIcon />
        </div>
      </div>
      <div className="preview-content-area">
        <div
          className="preview-content-body-area"
          dangerouslySetInnerHTML={{ __html: content || htmlContent }}
        ></div>
      </div>
    </div>
  );
};
